<div class="modal-header p-0">
    <button class="button-close base-btn" mat-button [mat-dialog-close]="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
        </svg>
    </button>
</div>

<div class="modal-body p-0" *ngIf="!data?.includeImageEstimate; else includeItem">

    <!-- ═══════════════════════════════════════════════
         STEP 1 — EMPLOYEE SIGNATURE
    ═══════════════════════════════════════════════ -->
    <ng-container *ngIf="currentStep === 'employee'">
        <div class="signature">
            <p class="pt-0">Collect Signature <span class="sig-role">(Authorized Company Representative)</span></p>

            <div class="sig-meta">
                <div class="sig-meta-item">
                    <span class="sig-meta-label">Employee</span>
                    <span class="sig-meta-value">{{ this.adminProfile?.fullName || '—' }}</span>
                </div>
                <div class="sig-meta-item">
                    <span class="sig-meta-label">Date</span>
                    <span class="sig-meta-value">{{ today | date: dateFormat }}</span>
                </div>
            </div>

            <div class="form-group text-start">
                <label class="mb-3">Draw Here</label>
                <div class="signPad" #employeeSignPadContainer>
                    <ngx-signature-pad #employeeSignaturePad class="display-sign-pad"
                        (signature)="onEmployeeSignature($event)"
                        [containerStyle]="'margin:0px auto;cursor:pointer;display:block;border-radius:9px;border: 1px solid #E8E8E8;height:300px'"
                        [height]="300" [lineStroke]="4" [lineColor]="'#000000'">
                    </ngx-signature-pad>
                </div>
            </div>
        </div>

        <div class="footerSec">
            <button type="button" class="btn base-btn cancel" [mat-dialog-close]="false">Cancel</button>
            <button type="button" class="btn base-btn reset me-4"
                (click)="clearEmployee(employeeSignaturePad)">Reset</button>
            <button type="submit" class="btn base-btn submit" [disabled]="isEmployeeSignatureEmpty"
                (click)="proceedToCustomer(employeeSignaturePad)">Proceed</button>
        </div>
    </ng-container>


    <!-- ═══════════════════════════════════════════════
         STEP 2 — CUSTOMER SIGNATURE
    ═══════════════════════════════════════════════ -->
    <ng-container *ngIf="currentStep === 'customer'">
        <div class="d-flex align-items-center handIcon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
                (click)=" goBackToEmployee()">
                <path d="M8.77251 5.43563L3.20834 10.9998L8.77251 16.564" stroke="#292D32" stroke-width="1.375"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.7917 11L3.36417 11" stroke="#292D32" stroke-width="1.375" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <!-- Unchecked items table -->
        <ng-container *ngIf="initialPage && uncheckedEstimate.length > 0">
            <p class="pt-0 include">Do you want to include this item(s)?</p>
            <div class="table">
                <table>
                    <thead class="p-2">
                        <tr>
                            <th>S.no</th>
                            <!-- <th>SKU</th> -->
                            <th>Image</th>
                            <th>Item Name</th>
                            <th>Description</th>
                            <th>Video</th>
                            <th>Script</th>
                            <th>Charge Type</th>
                            <th>Price</th>
                            <th>Tax</th>
                            <th>Qty</th>
                            <th>Total</th>
                            <th>Inspection</th>
                            <th>Include</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let estimate of uncheckedEstimate; let i = index" class="example-box">
                            <ng-container *ngIf="!estimate.noData">
                                <td class="index-column">{{ i + 1 }}</td>
                                <!-- <td class="sku-column">{{ estimate.sku || '---' }}</td> -->
                                <td class="media-column">
                                    <div *ngIf="estimate?.images?.length > 1; else showSingleImage" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.images.length - 1) }}</span>
                                        <div class="image">
                                            <img [src]="estimate.images[0].link" width="28px" height="28px"
                                                class="rounded-circle">
                                        </div>
                                    </div>
                                    <ng-template #showSingleImage>
                                        <img *ngIf="estimate?.images?.length; else noMedia"
                                            [src]="estimate.images[0].link" width="28px" height="28px"
                                            class="rounded-circle">
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td>{{ estimate['itemName'] }}</td>
                                <td class="description">
                                    <div>{{ estimate['description'] }}</div>
                                </td>
                                <td>
                                    <div *ngIf="estimate?.videos?.length > 1; else showSingleVideo" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.videos.length - 1) }}</span>
                                        <div class="image">
                                            <video [src]="estimate.videos[0].link" width="28px" height="28px"
                                                class="rounded-circle"></video>
                                        </div>
                                    </div>
                                    <ng-template #showSingleVideo>
                                        <video *ngIf="estimate?.videos?.length; else noMedia"
                                            [src]="estimate.videos[0].link" width="28px" height="28px"
                                            class="rounded-circle"></video>
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td class="description">
                                    <div>{{ estimate['script'] }}</div>
                                </td>
                                <td>{{ estimate['chargeType'] }}</td>
                                <td>{{ estimate['price'] ? '$' + (estimate['price'].toFixed(2)) : '$0.00' }}</td>
                                <td>{{ estimate['tax'] ? '$' + estimate['tax'] : '$0.00' }}</td>
                                <td>{{ estimate['quantity'] }}</td>
                                <td>{{ estimate['total'] ? '$' + (estimate['total'].toFixed(2)) : '$0.00' }}</td>
                                <td>
                                    <span class="btn w-100" [ngClass]="setInspectionStatus(estimate.inspectionId)">
                                        {{ estimate.inspectionStatus || '---' }}
                                    </span>
                                </td>
                                <td>
                                    <input class="form-check-input" type="checkbox"
                                        [checked]="checkedEstimate.includes(estimate?._id)"
                                        (change)="estimateChecked(estimate?._id)" />
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <!-- Totals -->
        <div class="w-100">
            <hr class="dashed-line" *ngIf="uncheckedEstimate.length > 0" />
            <div class="py-3">
                <div class="d-flex justify-content-between align-items-center amount">
                    <h3 class="amount-heading pb-0 mb-0">SubTotal</h3>
                    <span class="amount-heading">{{ '$' + (calculateAmount('total') - calculateAmount('tax')).toFixed(2)
                        }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center amount">
                    <h3 class="amount-breakup pb-0 mb-0">Tax</h3>
                    <span class="amount-breakup">{{ '$' + calculateAmount('tax') }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center amount">
                    <h3 class="amount-breakup pb-0 mb-0">Total</h3>
                    <span class="amount-breakup">{{ '$' + calculateAmount('total') }}</span>
                </div>
            </div>
        </div>

        <!-- Customer Signature -->
        <div class="signature">
            <p class="pt-0">Collect Signature <span class="sig-role">(Customer Authorization to Proceed)</span></p>

            <div class="sig-meta">
                <div class="sig-meta-item">
                    <span class="sig-meta-label">Customer</span>
                    <!-- Editable customer name -->
                    <span class="sig-meta-value customer-name-wrap">
                        <span *ngIf="!editingCustomerName" class="customer-name-display"
                            (click)="startEditCustomerName()">
                            {{ customerName || '—' }}
                            <svg class="edit-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13"
                                height="13">
                                <path
                                    d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7.8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
                            </svg>
                        </span>
                        <input *ngIf="editingCustomerName" #customerNameInput class="customer-name-input"
                            [(ngModel)]="customerName" (blur)="finishEditCustomerName()"
                            (keydown.enter)="finishEditCustomerName()" (keydown.escape)="cancelEditCustomerName()" />
                    </span>
                </div>
                <div class="sig-meta-item">
                    <span class="sig-meta-label">Date</span>
                    <span class="sig-meta-value">{{ today | date: dateFormat }}</span>
                </div>
            </div>

            <div class="form-group text-start">
                <label class="mb-3">Draw Here</label>
                <div class="signPad" #customerSignPadContainer>
                    <ngx-signature-pad #customerSignaturePad class="display-sign-pad"
                        (signature)="onCustomerSignature($event)"
                        [containerStyle]="'margin:0px auto;cursor:pointer;display:block;border-radius:9px;border: 1px solid #E8E8E8;height:300px'"
                        [height]="300" [lineStroke]="4" [lineColor]="'#000000'">
                    </ngx-signature-pad>
                </div>
            </div>
        </div>

        <div class="footerSec">
            <button type="button" class="btn base-btn cancel" [mat-dialog-close]="false">Cancel</button>
            <button type="button" class="btn base-btn reset me-4"
                (click)="clearCustomer(customerSignaturePad)">Reset</button>
            <button type="submit" class="btn base-btn submit" [disabled]="isCustomerSignatureEmpty"
                (click)="getFile(customerSignaturePad)">Confirm Approval</button>
        </div>

    </ng-container>

</div>

<ng-template #includeItem>
    <div class="modal-body p-0">
        <ng-container *ngIf="imageIncludeEstimateList.length > 0">
            <p class="pt-0 include text-align-center ">Do you want to include the images for these item(s) in the PDF?
            </p>
            <div class="table">
                <table>
                    <thead class="p-2">
                        <tr>
                            <th>S.no</th>
                            <th>Image</th>
                            <th>Item Name</th>
                            <th>Description</th>
                            <th>Video</th>
                            <th>Script</th>
                            <th>Charge Type</th>
                            <th>Price</th>
                            <th>Tax</th>
                            <th>Qty</th>
                            <th>Total</th>
                            <th>Inspection</th>
                            <th>
                                Include Images
                                <input class="form-check-input ms-1" type="checkbox" [checked]="isAllChecked()" matTooltip="Select All"
                                    (change)="toggleAll($event)" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let estimate of imageIncludeEstimateList; let i = index" class="example-box">
                            <ng-container *ngIf="!estimate.noData">
                                <td class="index-column">{{ i + 1 }}</td>
                                <!-- <td class="sku-column">{{ estimate.sku }}</td> -->
                                <td class="media-column">
                                    <div *ngIf="estimate?.images?.length > 1; else showSingleImage" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.images.length - 1) }}</span>
                                        <div class="image">
                                            <img [src]="estimate.images[0].link" width="28px" height="28px"
                                                class="rounded-circle">
                                        </div>
                                    </div>
                                    <ng-template #showSingleImage>
                                        <img *ngIf="estimate?.images?.length; else noMedia"
                                            [src]="estimate.images[0].link" width="28px" height="28px"
                                            class="rounded-circle">
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td>{{ estimate['itemName'] }}</td>
                                <td class="description">
                                    <div>{{ estimate['description'] }}</div>
                                </td>
                                <td>
                                    <div *ngIf="estimate?.videos?.length > 1; else showSingleVideo" class="more-images">
                                        <span class="rounded-circle">{{ '+' + (estimate.videos.length - 1) }}</span>
                                        <div class="image">
                                            <video [src]="estimate.videos[0].link" width="28px" height="28px"
                                                class="rounded-circle"></video>
                                        </div>
                                    </div>
                                    <ng-template #showSingleVideo>
                                        <video *ngIf="estimate?.videos?.length; else noMedia"
                                            [src]="estimate.videos[0].link" width="28px" height="28px"
                                            class="rounded-circle"></video>
                                        <ng-template #noMedia>
                                            <div>---</div>
                                        </ng-template>
                                    </ng-template>
                                </td>
                                <td class="description">
                                    <div>{{ estimate['script'] }}</div>
                                </td>
                                <td>{{ estimate['chargeType'] }}</td>
                                <td>{{ estimate['price'] ? '$' + (estimate['price'].toFixed(2)) : '$0.00' }}</td>
                                <td>{{ estimate['tax'] ? '$' + estimate['tax'] : '$0.00' }}</td>
                                <td>{{ estimate['quantity'] }}</td>
                                <td>{{ estimate['total'] ? '$' + (estimate['total'].toFixed(2)) : '$0.00' }}</td>
                                <td>
                                    <span class="btn w-100" [ngClass]="setInspectionStatus(estimate.inspectionId)">
                                        {{ estimate.inspectionStatus || '---' }}
                                    </span>
                                </td>
                                <td>
                                    <input class="form-check-input" type="checkbox"
                                        [checked]="checkedEstimate.includes(estimate?._id)"
                                        (change)="estimateChecked(estimate?._id)" />
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
        <div class="footerSec">
            <button type="button" class="btn base-btn cancel" [mat-dialog-close]="false">Cancel</button>
            <button type="submit" class="btn base-btn submit" (click)="download()">Download</button>
        </div>
    </div>
</ng-template>